// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_1vC4B"};